import React from 'react';
import NavBAr from './components/NavBar/NavBAr';
import Banner from './components/Banner/Banner';
import './App.css';
import RowPost from './components/RowPost/RowPost';
import RowPost2 from './components/RowPost/RowPost2';
import Footer from './components/Footer/footer';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './components/Signup/Login';

function App() {
    return (
        <div className='App'>
            <BrowserRouter>
                <Routes> <Route path="/login" element={<Login />} /></Routes>
                <NavBAr />
                <Banner />
                <RowPost title='SCREENFLIX ORIGINALS' />// Example usage for different languages
                <RowPost2 title="Action Movies" languageCode="en" />
                <RowPost2 title="Tamil Movies" languageCode="ta" />
                <RowPost2 title="Malayalam Movies" languageCode="ml" />
                <RowPost2 title="Hindi Movies" languageCode="hi" />
                <RowPost2 title="Telengu Movies" languageCode="te" />
                <RowPost2 title="Chinees Movies" languageCode="zh" />
                <RowPost2 title="Cartoons" languageCode="ja" />
                <RowPost2 title="Bengali Movies" languageCode="bn" />
                <RowPost2 title="Gujarathi Movies Movies" languageCode="gu" />
                <RowPost2 title="French Movies" languageCode="fr" />
                <RowPost2 title="Spanish Movies" languageCode="es" />
                <RowPost2 title="German Movies" languageCode="de" />
                <RowPost2 title="English classic Movies" languageCode="ka" />
                <RowPost2 title="Korean Drama Movies" languageCode="ko" />



                <Footer />
            </BrowserRouter>
        </div>
    );
}

export default App;
